// extracted by mini-css-extract-plugin
module.exports = {"container":"CartItemsTray_container__4SjNV","title":"CartItemsTray_title__QDFdK","actions":"CartItemsTray_actions__1bI2c","expressPayments":"CartItemsTray_expressPayments__FEd9c"};